import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toArray from "@babel/runtime/helpers/toArray";
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * The Roma form is doing some localisation stuff.
 * We'll be replacing all this with something that will be pulling from Prismic and/or SimpleLocalise,
 * we're using this dummy wrapper as a quick solution so we can get the form working as-is and worry about
 * proper localisation later.
 */

import React from 'react';
var _replacer = function replacer(input, replacements) {
  var _replacements = _toArray(replacements),
    nextReplacement = _replacements[0],
    queued = _arrayLikeToArray(_replacements).slice(1);
  if (!nextReplacement) return input;
  var output = input.map(function (node, index) {
    if (typeof node !== 'string') return node;
    var parts = node.split(new RegExp("</?".concat(nextReplacement.key, ">")));
    if (parts.length === 1) return node;
    var _parts = _slicedToArray(parts, 3),
      before = _parts[0],
      replacement = _parts[1],
      after = _parts[2];
    if (nextReplacement.key === 'and') {
      return [before, 'and', after];
    }
    var withChildren = /*#__PURE__*/React.cloneElement(nextReplacement.replacement, {
      key: "replacement-".concat(index)
    }, replacement);
    return [before, withChildren, after].filter(function (part) {
      return part !== '';
    });
  }).flat();
  return _replacer(output, queued);
};
var dummyTranslator = function dummyTranslator(_key, defaultText, _context, options) {
  if (!(options !== null && options !== void 0 && options.components)) return defaultText;
  var replacements = Object.entries(options.components).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      replacement = _ref2[1];
    return {
      key: key,
      replacement: replacement
    };
  });
  return _replacer([defaultText], replacements);
};
export var useTranslator = function useTranslator(_namespace, _keyPrefix) {
  return dummyTranslator;
};